(function () {
  if (window.ucCartVariantFixLoaded) return;
  window.ucCartVariantFixLoaded = true;

  var productCache = {};
  var hydrateTimer = null;

  function rootUrl() {
    var root = window.routes && window.routes.root ? window.routes.root : window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function handleForItem(item) {
    if (item.handle) return item.handle;
    var match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product lookup failed.');
        return response.json();
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function optionLabel(product, variant) {
    if (!variant) return '';
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return product && product.title ? product.title : 'Default';
  }

  function buildSelect(item, product) {
    if (!product || !product.variants || product.variants.length < 2) return '';

    var options = product.variants.map(function (variant) {
      var isCurrent = Number(variant.id) === Number(item.variant_id);
      var disabled = !variant.available && !isCurrent;
      return '<option value="' + variant.id + '"' +
        (isCurrent ? ' selected' : '') +
        (disabled ? ' disabled' : '') +
        '>' + escapeHtml(optionLabel(product, variant)) + (disabled ? ' - Sold out' : '') + '</option>';
    }).join('');

    return '<label class="uc-cart-line__select-wrap uc-cart-line__select-wrap--dynamic">' +
      '<span>Variant</span>' +
      '<select class="uc-cart-line__select" data-line-key="' + escapeHtml(item.key) + '">' + options + '</select>' +
      '</label>';
  }

  function lineForItem(item) {
    var lines = document.querySelectorAll('.uc-cart-line[data-line-key]');
    for (var i = 0; i < lines.length; i += 1) {
      if (lines[i].getAttribute('data-line-key') === item.key) return lines[i];
    }
    return null;
  }

  function insertSelect(line, markup) {
    if (!line || !markup || line.querySelector('.uc-cart-line__select-wrap')) return;
    var bottom = line.querySelector('.uc-cart-line__bottom');
    if (bottom) {
      bottom.insertAdjacentHTML('beforebegin', markup);
      return;
    }
    var body = line.querySelector('.uc-cart-line__body') || line;
    body.insertAdjacentHTML('beforeend', markup);
  }

  function hydrate(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();

    return Promise.all(cart.items.map(function (item) {
      var line = lineForItem(item);
      if (!line || line.querySelector('.uc-cart-line__select-wrap')) return Promise.resolve();

      return fetchProduct(handleForItem(item)).then(function (product) {
        insertSelect(line, buildSelect(item, product));
      });
    }));
  }

  function scheduleHydrate(cart) {
    window.clearTimeout(hydrateTimer);
    hydrateTimer = window.setTimeout(function () {
      if (cart && cart.items) {
        hydrate(cart);
        return;
      }
      fetchCart().then(hydrate).catch(function () {});
    }, 80);
  }

  document.addEventListener('uc:cart:updated', function (event) {
    scheduleHydrate(event.detail);
  });

  document.addEventListener('DOMContentLoaded', function () {
    scheduleHydrate();
    var wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (wrapper && window.MutationObserver) {
      new MutationObserver(function () {
        scheduleHydrate();
      }).observe(wrapper, { childList: true, subtree: true });
    }
  });
})();
